import { useCart } from "@/hooks/useCart";
import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { cn, formatPrice } from "@/lib/utils";

type OrderSummaryFooterProps = {
  className?: string;
  locale: Locales;
};

const OrderSummaryFooter = ({ className, locale }: OrderSummaryFooterProps) => {
  const { cart } = useCart();

  return (
    <dl className={cn("border-primary-light/50 border-t pt-5", className)}>
      <div className="flex items-center justify-between">
        <dd className="text-primary-light">{__("Total VAT exc.", locale)}</dd>
        <dt>{formatPrice(cart?.subtotal || 0)}</dt>
      </div>
      {!!cart?.discount_total && (
        <div className="flex items-center justify-between">
          <dd className="text-primary-light">{__("Promo code", locale)}</dd>
          <dt> -{formatPrice(cart?.discount_total || 0)}</dt>
        </div>
      )}
      <div className="flex items-center justify-between">
        <dd className="text-primary-light">{__("VAT (21%)", locale)}</dd>
        <dt>{formatPrice(cart?.tax_total || 0)}</dt>
      </div>
      <hr className="border-primary-light/50 my-5" />
      <div className="flex items-start justify-between">
        <dd className="leading-h1 text-lg font-semibold">
          {__("Total VAT", locale)}* <br />
          <span className="text-primary-light text-xs font-normal">{__("Delivery costs not included", locale)}</span>
        </dd>
        <dt className="text-xl font-semibold">{formatPrice(cart?.total || 0)}</dt>
      </div>
    </dl>
  );
};

export default OrderSummaryFooter;
